import React from 'react';
import { useSelector } from 'react-redux';
import BadgeCmp from 'src/components/BadgeCmp';
import CardCmp from 'src/components/CardCmp';
import EntityChatView from 'src/components/EntityChatView';
import MessageCardSkeleton from 'src/components/EntityChatView/components/MessageCardSkeleton';
import { RootState } from 'src/redux/store';

import { useRadarData } from '../../hooks/useRadarData';

const InternalChatSection: React.FC = () => {
    const { trackOrderDetail, isDetailLoading } = useRadarData();
    const { unreadCount, isLoading } = useSelector((state: RootState) => state.orderChat);
    const hasUnread = unreadCount > 0;

    const masterOrderId = trackOrderDetail?.masterOrderId ?? null;

    if (!masterOrderId && !isDetailLoading) return null;

    if (!masterOrderId && isDetailLoading) {
        return (
            <CardCmp
                headerTitle="Chat"
                isCardContentWithoutSpacing={true}
                isCardFooterWithoutSpacing={true}
                footerParentClassName="widget-card-footer-wrap"
                childrenClassName=""
                isHeaderWithBg
                isFooter={true}
                footerLeftSideContent={null}
            >
                <ul className="h-[192px] overflow-hidden flex flex-col px-4 py-2">
                    <MessageCardSkeleton />
                </ul>
            </CardCmp>
        );
    }

    return (
        <CardCmp
            headerTitle="Chat"
            isCardContentWithoutSpacing={true}
            isCardFooterWithoutSpacing={true}
            footerParentClassName="widget-card-footer-wrap"
            childrenClassName=""
            isHeaderWithBg
            headerLeftSideContent={
                isLoading || hasUnread ? (
                    <BadgeCmp style="modern" type="orange" mainClassName={`relative ${isLoading ? 'custom-loading' : ''}`} isHidePillDot={true}>
                        {isLoading ? '0' : unreadCount}
                        {hasUnread && <div className="absolute -top-1 -right-1 w-2 h-2 bg-danger600 rounded-full" />}
                    </BadgeCmp>
                ) : null
            }
            isFooter={true}
            footerLeftSideContent={null}
        >
            <EntityChatView
                entityId={masterOrderId}
                entityType="order"
                isActive={true}
                mainLoading={isDetailLoading}
                hideHeader={true}
                isFromWidget={true}
                autoFocusInput={false}
                chatContainerClassName="h-[192px] max-h-[192px] min-h-[192px]"
            />
        </CardCmp>
    );
};

export default InternalChatSection;
